/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import { Icon, ToolTip } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageindicator/imageindicator_styles';



/* ========== ~~~~~~~~~~ IMAGE INDICATOR ~~~~~~~~~~ ========== */
const ImageIndicator = ({classes}) => {
    return (
        <div className={`imageindicator ${classes.imageindicator}`}>
            <ToolTip position={`top`} action={`mouseenter`} content={`Select an image`}>
                <Icon name={`image`} />
            </ToolTip>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageIndicator);
